import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { CircularProgress, Checkbox, FormControlLabel, Switch } from "@mui/material";

import Multiselect from "multiselect-react-dropdown";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  maxWidth: 450,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  paddingTop: 1,
  paddingBottom: 4,
  paddingLeft: 4,
  paddingRight: 4,
  maxHeight:"90%",
  overflow:"scroll"
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "32ch",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  label: {
    fontWeight: "bold",
  },
  chip: {
    color: "black",
  },
}));

const TAB_OPTIONS = [
  "truink",
  "support",
  "emms",
  "changepassword",
];

const INITIAL_FORM_STATE = {
  email: "",
  isMFAEnabled: false,
  customProperties: {
    tabs: [],
    admin: false,
    maker: false,
    checker: false,
  },
};




export  function MyUserForm({ editMode, userData, onSuccess ,setSelectedUserForEdit ,sites,setUsers,groups}) {
  const [open, setOpen] = React.useState(false);

  const classes = useStyles();
  const headers = useSelector((state) => state.header);
  const api = localStorage.getItem("api");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);

  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [initialUserData,setInitialUserData]=useState({})
  const [resetMFAConfig,setResetMFACongig]=useState(false)

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const siteOptions = React.useMemo(()=>{
    return (sites || [])?.map(s=>s.name)
  },[sites])


  const toBoolean = (value) => value === true || value === "true"; 

  const transformUser = (user, sites) => ({
  id: user.id,
  email: user.email,
  admin: toBoolean(user.customProperties?.admin),
  maker: toBoolean(user.customProperties?.maker),
  checker: toBoolean(user.customProperties?.checker),
  tabs: user.customProperties?.tabs?.join(", ") || "",
  isMFAEnabled: user.isMFAEnabled,
  sites:
    (sites || [])
      .filter((site) => user.siteIds?.includes(site.id))
      .map((site) => site.name)
      .filter(Boolean)
      .join(", "),
  groups:
   (groups || [])
      .filter((group) =>
        user.customProperties?.belongsTo?.includes(group.id)
      )
      .map((group) => group.name)
      .join(", "),

  groupIds: user.customProperties?.belongsTo || [],
});

  const siteNameToIdMap = React.useMemo(() => {
    const map = {};
    (sites || []).forEach((s) => {
      map[s.name] = s.id;
    });
    return map;
  }, [sites]);

  const resetForm = () => {
    setFormData(INITIAL_FORM_STATE);
    setSelectedTabs([]);
    setSelectedSites([]);
  };

  const handleOpen = () => {
    if (!editMode) {
      resetForm();
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUserForEdit({})
  };

 useEffect(() => {
  if (editMode && userData) {
    const tabs = (userData?.tabs || "")
                        .split(",")
                        .map((t) => t.trim())
                        .filter(Boolean);
    const siteNames = (userData?.sites || "")
                                          .split(",")
                                          .map((s) => s.trim())
                                          .filter(Boolean);
    const siteIds = siteNames
      .map((name) => siteNameToIdMap[name])
      .filter(Boolean);

    const allowedTabs = (tabs || []).filter((tab) => TAB_OPTIONS.includes(tab)); 

    const initialData = {
      email: userData?.email ?? "",
      isMFAEnabled: userData?.isMFAEnabled || false,
      customProperties: {
        tabs: tabs,
        admin: toBoolean(userData?.admin),
        maker: toBoolean( userData?.maker),
        checker: toBoolean(userData?.checker),
        belongsTo:userData?.groupIds
      },
      siteIds,
    };

    setInitialUserData(initialData);

    setFormData({
    ...initialData,
    customProperties: {
      ...initialData.customProperties,
      tabs: userData?.isSuperAdmin ?tabs: allowedTabs,
    },
    });   
    
    setSelectedTabs(allowedTabs);
    setSelectedSites(siteNames);
  }
}, [editMode, userData, siteNameToIdMap]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePermissionChange = (event) => {
    const { name, checked } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        [name]: checked,
      },
    }));
  };

  const handleMFAChange = (event) => {
    const { checked } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      isMFAEnabled: checked,
    }));
  };

  const handleTabsChange = (selectedList) => {
    setSelectedTabs(selectedList);
    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        tabs: selectedList,
      },
    }));
  };

  const handleSitesChange = (selectedList) => {
    setSelectedSites(selectedList);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validateForm = () => {
    const trimmedEmail = formData.email.trim();

    if (trimmedEmail.length === 0) {
      setErrorModalOpen(true);
      setError(true);
      setErrorMessage("Please provide all required fields");
      return false;
    }

    if (!isValidEmail(trimmedEmail)) {
      setErrorModalOpen(true);
      setError(true);
      setErrorMessage("Please provide a valid email address");
      return false;
    }

    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    let body = {};

if (!editMode) {
  // CREATE
  const siteIds = selectedSites
    .map((name) => siteNameToIdMap[name])
    .filter(Boolean);

  body = {
    email: formData.email.trim(),
    isMFAEnabled: formData.isMFAEnabled,
    siteIds,
    customProperties: {
      tabs: formData.customProperties.tabs,
      admin: toBoolean(formData.customProperties.admin),
      maker: toBoolean(formData.customProperties.maker),
      checker: toBoolean(formData.customProperties.checker),
      belongsTo:formData?.customProperties?.belongsTo || []
    },
  };
} else {
  // EDIT
  body.id = userData.id;

  if (formData.email.trim() !== initialUserData.email) {
    body.email = formData.email.trim();
  }



  if (formData.isMFAEnabled !== initialUserData.isMFAEnabled) {
    body.isMFAEnabled = formData.isMFAEnabled;
  }

  const customPropertiesChanged =
  JSON.stringify({
    tabs: [...(formData?.customProperties?.tabs || [])].sort(),
    admin: formData.customProperties.admin,
    maker: formData.customProperties.maker,
    checker: formData.customProperties.checker,
    belongsTo: [...(formData?.customProperties.belongsTo || [])].sort(),
  }) !==
  JSON.stringify({
    tabs: [...(initialUserData?.customProperties?.tabs || [])].sort(),
    admin: initialUserData.customProperties?.admin,
    maker: initialUserData.customProperties?.maker,
    checker: initialUserData.customProperties?.checker,
    belongsTo: [...(initialUserData?.customProperties?.belongsTo || [])].sort(),
  });

  if (customPropertiesChanged) {
    body.customProperties = {
      tabs: formData.customProperties.tabs,
      admin: toBoolean(formData.customProperties?.admin),
      maker: toBoolean(formData.customProperties?.maker),
      checker: toBoolean(formData.customProperties?.checker),
      belongsTo:formData?.customProperties?.belongsTo
    };
  }

  const selectedSiteIds = selectedSites
    .map((name) => siteNameToIdMap[name])
    .filter(Boolean);

  const sitesChanged =
    JSON.stringify(selectedSiteIds) !==
    JSON.stringify(initialUserData.siteIds || []);

  if (sitesChanged) {
    body.siteIds = selectedSiteIds;
      }
    }

    if(editMode && resetMFAConfig) {
      body.mfaConfig ={}
    }


    const requestBody = {
      path: "user",
      query: {},
      body: body, 
      requestType: "POST",
    };

    axios
      .post(api + "/auth/piggyback", requestBody, headers)
      .then((response) => {


        const updatedUser = transformUser(response.data, sites);

        if (editMode) {
          setUsers((prev) =>
            prev.map((user) =>
              user.id === updatedUser.id ? updatedUser : user
            )
          );
        } else {
          setUsers((prev) => [...prev, updatedUser]);
        }
        setIsSubmitting(false);
        setErrorModalOpen(true);
        setError(false);
        setResetMFACongig(false)
        setErrorMessage(
          editMode ? "User updated successfully" : "User created successfully"
        );
        onSuccess?.(response.data);
      })
      .catch((error) => {
        setIsSubmitting(false);
        setErrorModalOpen(true);
        setError(true);
        setErrorMessage(`Error saving user: ${error.response?.data}`);
      });
  };

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");

    if (!error) {
      setOpen(false);
      setSelectedUserForEdit({})
      resetForm();
    }
  };

  useEffect(()=>{
    if(editMode) setOpen(true)  
  },[editMode])


    const selectedGroups = React.useMemo(() => {
      const groupIds = formData?.customProperties?.belongsTo || [];

      return groups
        ?.filter((group) => groupIds.includes(group.id))
        ?.map((group) => ({
          id: group.id,
          name: group.name,
        })) || [];
    }, [groups, formData?.customProperties?.belongsTo]);


    const handleGroupsChange = (selectedList) => {
        setFormData((prev) => ({
          ...prev,
          customProperties: {
            ...prev.customProperties,
            belongsTo: selectedList.map((group) => group.id),
          },
        }));
      };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
   <div>
  <Button
    style={{ textTransform: "none" }}
    variant="contained"
    color="primary"
    onClick={handleOpen}
  >
    {editMode ? "Edit User" : "Add User"}
  </Button>
  <Modal
    open={open}
    onClose={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Box sx={style}>
      <form
        className={classes.root}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <div>
          <div>
            <h2>{editMode ? "Edit User" : "Create User"}</h2>
            <h4 style={{ fontWeight: "100" }}>
              {editMode
                ? `Update details for ${userData?.email ?? "this user"}`
                : "Add a new user"}
            </h4>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "8px",
            }}
          >
            <div style={{ minWidth: "110px" }}>
              {getLabelWithAsterisk("Email:", true)}
            </div>
            <TextField
              required
              id="email"
              name="email"
              label="Email"
              size="small"
              variant="outlined"
              value={formData.email}
              onChange={handleChange}
              style={{ width: isMobile ? "100%" : "350px",margin:0 }}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              marginBottom: "8px",
            }}
          >
            <div style={{ minWidth: "110px", paddingTop: "6px" }}>
              {getLabelWithAsterisk("Tabs:", false)}
            </div>
            <div style={{ width: isMobile ? "100%" : "350px" }}>
              <Multiselect
                id="tabs"
                name="tabs"
                isObject={false}
                onRemove={handleTabsChange}
                onSelect={handleTabsChange}
                options={TAB_OPTIONS}
                selectedValues={selectedTabs}
                style={{
                  chips: {
                    background: "#19433E",
                  },
                  option: {
                    background: "#19433E",
                  },
                  searchBox: {
                    border: "1px solid lightgray",
                    width: "100%",
                    minHeight: "40px",
                  },
                  optionContainer: {
                    maxHeight: "100px",
                    overflowY: "auto",
                  },
                }}
              />
            </div>
          </div>


          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              marginBottom: "8px",
            }}
          >
            <div style={{ minWidth: "110px", paddingTop: "6px" }}>
              {getLabelWithAsterisk("Sites :", false)}
            </div>
            <div style={{ width: isMobile ? "100%" : "350px" }}>
              <Multiselect
                id="sites"
                name="sites"
                isObject={false}
                onRemove={handleSitesChange}
                onSelect={handleSitesChange}
                options={siteOptions}
                selectedValues={selectedSites}
                style={{
                  chips: {
                    background: "#19433E",
                  },
                  option: {
                    background: "#19433E",
                  },
                  searchBox: {
                    border: "1px solid lightgray",
                    width: "100%",
                    minHeight: "40px",
                  },
                  optionContainer: {
                    maxHeight: "100px",
                    overflowY: "auto",
                  },
                }}
              />
            </div>

          </div>

             <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              marginBottom: "8px",
            }}
          >
            <div style={{ minWidth: "110px", paddingTop: "6px" }}>
              {getLabelWithAsterisk("Groups :", false)}
            </div>
            <div style={{ width: isMobile ? "100%" : "350px" }}>
             <Multiselect
              id="groups"
              name="groups"
              displayValue="name"
              isObject={true}
              options={groups}
              selectedValues={selectedGroups}
              onSelect={handleGroupsChange}
              onRemove={handleGroupsChange}
              style={{
                chips: {
                  background: "#19433E",
                },
                option: {
                  background: "#19433E",
                },
                searchBox: {
                  border: "1px solid lightgray",
                  width: "100%",
                  minHeight: "40px",
                },
                optionContainer: {
                  maxHeight: "100px",
                  overflowY: "auto",
                },
              }}
            />
            </div>

          </div>



          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              marginBottom: "8px",
            }}
          >
            <div style={{ minWidth: "110px", paddingTop: "4px" }}>
              {getLabelWithAsterisk("Permissions:", false)}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="admin"
                    checked={formData.customProperties.admin}
                    onChange={handlePermissionChange}
                  />
                }
                label="Admin"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="maker"
                    checked={formData.customProperties.maker}
                    onChange={handlePermissionChange}
                  />
                }
                label="Maker"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="checker"
                    checked={formData.customProperties.checker}
                    onChange={handlePermissionChange}
                  />
                }
                label="Checker"
              />
            </div>
          </div>






           <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              marginBottom: "8px",
            }}
          >
            <div style={{ minWidth: "110px", paddingTop: "4px" }}>
              {getLabelWithAsterisk("MFA:", false)}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
             { editMode && <FormControlLabel
                control={
                  <Checkbox
                    name="admin"
                    checked={resetMFAConfig}
                    onChange={()=>setResetMFACongig((pre)=>!pre)}
                  />
                }
                label="Reset MFA"
              />}
            <FormControlLabel
              control={
                <Switch
                  name="isMFAEnabled"
                  checked={formData.isMFAEnabled}
                  onChange={handleMFAChange}
                />
              }
              label={formData.isMFAEnabled ? "Enabled" : "Disabled"}
            />

            

            </div>
          </div>

        </div>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "end",
            marginRight: "2%",
          }}
        >
          <Button
            style={{ textTransform: "none" }}
            variant="outlined"
            color="error"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            style={{ textTransform: "none" }}
            type="submit"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </Box>

        <Modal
          open={errorModalOpen}
          onClose={handleModalClose}
          className={classes.modal}
        >
          <div className={classes.paper}>
            <h2>{error === true ? "Oops" : "Congratulations"}</h2>
            <p>{errorMessage}</p>
            <Button
              style={{ textTransform: "none", marginLeft: "75%" }}
              onClick={handleModalClose}
              variant="contained"
              color="primary"
            >
              Close
            </Button>
          </div>
        </Modal>
      </form>
    </Box>
  </Modal>
</div>
  );
}